import React from "react";
import Tujuan1 from "@img/tujuan1.png";
import Tujuan2 from "@img/tujuan2.png";
import Tujuan3 from "@img/tujuan3.png";
import Materi from "@img/materi1.png";
import Key1 from "@img/key1.png";
import Key2 from "@img/key2.png";
import Key3 from "@img/key3.png";
import Key4 from "@img/key4.png";
import Key5 from "@img/key5.png";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

const Masjidpemberdaya = () => {
  const [empoweringMosque, setEmpoweringMosque] = useState([]);

  useEffect(() => {
    fetchEmpoweringMosque();
  }, []);

  const fetchEmpoweringMosque = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/empowering-mosques"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data masjid pemberdaya");
      }
      const data = await response.json();
      setEmpoweringMosque(data.data[0] || []);
    } catch (error) {
      setEmpoweringMosque([]);
    }
  };

  const keyImages = [Key1, Key2, Key3, Key4, Key5];

  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <div className="flex overflow-hidden relative flex-col justify-center items-center px-16 py-20 w-full min-h-[678px] max-md:px-5 max-md:max-w-full shadow-lg bg-white">
          <img
            loading="lazy"
            src={`${process.env.REACT_APP_API_URL}/${empoweringMosque.background_image}`}
            className="object-cover absolute inset-0 w-full h-full"
            alt="Header"
          />
          <div className="relative mt-16 mb-28 w-full max-w-[1174px] max-md:my-10 max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-[43%] max-md:ml-0 max-md:w-full">
                <div className="flex relative flex-col grow text-2xl font-bold leading-7 text-center text-white max-md:mt-10">
                  <img
                    loading="lazy"
                    src={`${process.env.REACT_APP_API_URL}/${empoweringMosque.image}`}
                    className="w-full aspect-[1.92]"
                    alt="logo"
                  />
                  <a
                    href={empoweringMosque.url}
                    className="justify-center bg-green-700 rounded-3xl max-md:px-5 mobile:px-4 mobile:py-4 mobile:mt-4 lg:px-12 lg:py-7 lg:mt-7"
                  >
                    Pelajari Selengkapnya
                  </a>
                </div>
              </div>
              <div className="flex flex-col mt-12 mobile:w-full lg:ml-7 lg:w-[57%]">
                <div className="flex flex-col mt-8 text-white max-md:mt-10 max-md:max-w-full">
                  <div className="mb-3 mt-10 text-4xl font-bold leading-10 max-md:max-w-full mobile:ml-4 lg:ml-8">
                    {empoweringMosque.title}
                  </div>
                  <div
                    className="mt-5 text-lg leading-7 text-justify mobile:ml-4 mobile:pr-4 lg:ml-10"
                    style={{ hyphens: "auto", wordBreak: "break-word" }}
                    dangerouslySetInnerHTML={{
                      __html: empoweringMosque.description,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Content tujuan masjid pemberdaya */}

        <div className="flex flex-col mt-20 mb-5 w-full max-w-[1217px] max-md:max-w-full mobile:px-6">
          <div className="text-5xl font-bold text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
            Tujuan/Outcome
          </div>
          <div className="text-lg text-neutral-700 max-md:mt-10 mobile:leading-7 mobile:mt-3 mobile:px-2 lg:leading-4 lg:mt-12">
            Yuk upgrade Wirausaha Masjid Kamu Bergabung Dengan OKOCE!
          </div>
          <div className="max-md:mt-10 max-md:max-w-full mobile:mt-2 lg:lg:mt-11">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
              <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow px-10 py-11 w-full text-xl leading-8 text-justify text-black bg-white rounded-3xl border border-indigo-800 border-solid shadow-sm max-md:px-5 max-md:mt-10 max-md:max-w-full">
                  <img
                    loading="lazy"
                    src={Tujuan1}
                    className="w-10 aspect-square"
                    alt=""
                  />
                  <div className="mt-4 max-md:max-w-full">
                    Menjadikan masjid memiliki kemampuan membiayai operasional
                    dan menciptakan lapangan kerja dari usaha yang dimiliki oleh
                    masjid
                  </div>
                </div>
              </div>
              <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                <div className="flex flex-col grow px-10 pt-9 pb-16 w-full text-xl leading-8 text-justify text-black bg-white rounded-3xl border border-indigo-800 border-solid shadow-sm max-md:px-5 max-md:mt-10 max-md:max-w-full">
                  <img
                    loading="lazy"
                    src={Tujuan2}
                    className="aspect-square w-[50px]"
                    alt=""
                  />
                  <div className="mt-4 max-md:max-w-full">
                    Membantu masjid untuk meningkatkan pendapatan karyawan/
                    imam/ muadzin/ marbot, minimal setara UMR
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col self-center px-10 py-14 mt-14 max-w-full text-xl leading-8 text-justify text-black bg-white rounded-3xl border border-indigo-800 border-solid shadow-sm w-[581px] max-md:px-5 max-md:mt-10">
            <img
              loading="lazy"
              src={Tujuan3}
              className="w-10 aspect-square"
              alt=""
            />
            <div className="mt-4 max-md:max-w-full">
              Menjadikan masjid sebagai pusat pengembangan ekonomi jamaah dan
              masyarakat sekitar.
            </div>
          </div>
        </div>

        {/* Content tujuan masjid pemberdaya end */}

        {/* OUTPUT Content */}
        <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-black leading-tight mb-12">
            OUTPUT
          </h2>
          <div className="w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {empoweringMosque.output_logo?.map((logo, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md transition-transform hover:scale-105"
                >
                  <img
                    loading="lazy"
                    src={`${process.env.REACT_APP_API_URL}/${logo}`}
                    className="w-full max-w-[200px] h-auto object-contain"
                    alt={`Output ${index + 1}`}
                  />
                  {/* Uncomment the line below if you want to add a caption */}
                  {/* <div className="mt-4 text-xl text-center">Masjid Memiliki Usaha</div> */}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Output Content end */}

        {/* pelaksana */}
        <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-black leading-tight mb-12">
            PELAKSANA DAN PENDUKUNG
          </h2>
          <div className="w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {empoweringMosque.support_logo?.map((logo, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md transition-transform hover:scale-105"
                >
                  <img
                    loading="lazy"
                    src={`${process.env.REACT_APP_API_URL}/${logo}`}
                    className="w-full max-w-[300px] h-auto object-contain"
                    alt={`Support Logo ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* pelaksana */}

        {/* PESERTA CONTENT  */}
        <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-black mb-12">
            PESERTA
          </h2>
          <div className="w-full max-w-4xl">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {empoweringMosque.member_logo?.map((logo, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md transition-transform hover:scale-105"
                >
                  <img
                    loading="lazy"
                    src={`${process.env.REACT_APP_API_URL}/${logo}`}
                    className="w-full max-w-[300px] h-auto object-contain"
                    alt={`Peserta ${index + 1}`}
                  />
                  {/* Uncomment the line below if you want to add a caption */}
                  {/* <div className="mt-4 text-xl text-center">Masjid Memiliki Usaha</div> */}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* PESERTA CONTENT END */}

        {/* DURASI CONTENT */}
        <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-black mb-12">
            DURASI
          </h2>
          <div className="w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {empoweringMosque.duration_logo?.map((logo, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md transition-transform hover:scale-105"
                >
                  <img
                    loading="lazy"
                    src={`${process.env.REACT_APP_API_URL}/${logo}`}
                    className="w-full max-w-[200px] h-auto object-contain"
                    alt={`Duration ${index + 1}`}
                  />
                  {/* Uncomment the line below if you want to add a caption */}
                  {/* <div className="mt-4 text-xl text-center">Masjid Memiliki Usaha</div> */}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* DURASI CONTENT END */}

        {/* TAHAPAN CONTENT */}
        <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-black mb-12">
            TAHAPAN
          </h2>
          <div className="w-full max-w-5xl">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {empoweringMosque.step_logo?.map((logo, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md transition-transform hover:scale-105"
                >
                  <img
                    loading="lazy"
                    src={`${process.env.REACT_APP_API_URL}/${logo}`}
                    className="w-full max-w-[200px] h-auto object-contain"
                    alt={`Step ${index + 1}`}
                  />
                  {/* Uncomment the line below if you want to add a caption */}
                  {/* <div className="mt-4 text-xl text-center">Masjid Memiliki Usaha</div> */}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* TAHAPAN CONTENT END */}

        {/* TIME LINE CONTENT */}
        <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-black mb-12">
            TIMELINE
          </h2>
          <div className="w-full max-w-5xl">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {empoweringMosque.timeline_logo?.map((logo, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md transition-transform hover:scale-105"
                >
                  <img
                    loading="lazy"
                    src={`${process.env.REACT_APP_API_URL}/${logo}`}
                    className="w-full max-w-[200px] h-auto object-contain"
                    alt={`Timeline ${index + 1}`}
                  />
                  {/* Uncomment the line below if you want to add a caption */}
                  {/* <div className="mt-4 text-xl text-center">Masjid Memiliki Usaha</div> */}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* TIME LINE CONTENT END */}

        {/* MATERI CONTENT */}
        <div className="flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="w-full max-w-5xl">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black text-center mb-4">
          MATERI
        </h2>
        <p className="text-lg text-neutral-700 text-center mb-12">
          Yuk upgrade Wirausaha Masjid Kamu Bergabung Dengan OKOCE
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {empoweringMosque?.material?.map(
            ({ material_title, material_description }, index) => (
              <div
                key={index}
                className="flex flex-col bg-white rounded-3xl border border-indigo-800 shadow-md overflow-hidden transition-transform hover:scale-105"
              >
                <div className="p-6 sm:p-8">
                  <img
                    src={Materi}
                    className="w-10 h-10 mb-4"
                    alt={`Materi ${index + 1}`}
                  />
                  <h3 className="text-2xl font-bold mb-4">{material_title}</h3>
                  <div
                    className="text-base leading-6 text-justify"
                    dangerouslySetInnerHTML={{
                      __html: material_description,
                    }}
                  />
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
        {/* MATERI CONTENT */}

        {/* KUNCI SUKSES */}
        <div className="flex flex-col items-center pt-6 pb-9 max-md:px-5 lg:px-16">
          <div className="flex flex-col mobile:w-4/5 lg:w-full">
            <div className="font-bold text-black max-md:max-w-full mobile:pl-4 mobile:text-2xl lg:text-5xl lg:pl-10">
              Kunci Sukses/Key Succes Factor
            </div>
            <div className="mt-8 text-lg leading-4 text-neutral-700 max-md:max-w-full mobile:pl-4 mobile:leading-7 lg:pl-10">
              Yuk upgrade Wirausaha Masjid Kamu Dengan Kunci Sukses dari OKOCE
            </div>
            <div className="self-center mobile:w-11/12 lg:mt-14 lg:w-10/12">
              <div className="flex gap-5 max-md:flex-col">
                <div className="flex flex-col max-md:w-full mobile:w-full lg:ml-4 lg:w-full">
                  <div className="grid grow justify-center leading-9 text-justify text-black max-md:mt-10 max-md:max-w-full mobile:grid-cols-1 mobile:gap-y-10 mobile:text-lg lg:grid-cols-2 lg:text-2xl lg:gap-6">
                    {empoweringMosque?.key?.map(
                      ({ key_description }, index) => (
                        <div
                          key={index}
                          className="flex flex-col py-10 bg-white rounded-3xl border border-indigo-800 border-solid shadow-sm max-md:max-w-full mobile:px-4 lg:px-6"
                        >
                          <img
                            loading="lazy"
                            src={keyImages[index % keyImages.length]}
                            className="w-10 aspect-square"
                            alt={`Key ${(index % keyImages.length) + 1}`}
                          />
                          <div
                            className="mt-4"
                            dangerouslySetInnerHTML={{
                              __html: key_description,
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FloatingMenu />{" "}
    </>
  );
};

export default Masjidpemberdaya;
